import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './Login.css'; // Reuse the same styling

function AutoLogin() {
  const [searchParams] = useSearchParams();
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const autoLogin = async () => {
      const code = searchParams.get('code');
      const redirectUri = searchParams.get('redirect_uri');
      const clientId = searchParams.get('client_id');
      const accountUid = searchParams.get('account');

      if (!code || !redirectUri || !clientId) {
        navigate('/login');
        return;
      }

      try {
        // Clear any existing auth token
        localStorage.removeItem('authToken');
        localStorage.removeItem('refreshToken');

        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/oauth/autologin`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            code: code,
            redirectUri: redirectUri,
            clientId: clientId,
            accountUid: accountUid
          }),
        });

        if (response.ok) {
          const data = await response.json();
          localStorage.setItem('authToken', data.access_token);
          localStorage.setItem('refreshToken', data.refresh_token);
          window.location.href = redirectUri;
        } else {
          setErrorMessage('Authentication failed. Please try logging in again.');
          setTimeout(() => {
            navigate('/login');
          }, 3000);
        }
      } catch (error) {
        console.error('Error during auto-login:', error);
        setErrorMessage('An unexpected error occurred. Redirecting to login...');
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    };

    autoLogin();
  }, [searchParams, navigate]);

  return (
    <div className="login-container">
      <div className="login-form">
        <img src="https://afterschoolhq.com/Assets/img/ahq-logo-2-1-1.png" alt="Logo" className="login-logo" />
        {errorMessage ? (
          <div className="error-message">{errorMessage}</div>
        ) : (
          <div>Logging in...</div>
        )}
      </div>
    </div>
  );
}

export default AutoLogin;
